<template lang="pug">
    .content-detail
      Cargo(:item="item", :type='t')

</template>

<script type="text/babel">

import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
import Cargo from "../../../components/backoffice/Cargo";


export default {
  name: 'CargoOperationController',
  components: {Cargo},
  data() {
    return {
      component: require('src/components/backoffice/Cargo'),
      id: null,
      item: '',
      t: 'detail'
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.dataLoader()
  },

  methods: {
    dataLoader() {
      KeplerBackofficeSdk.cargo.getOperation(this.id, data => {
        this.item = data
        console.log(this.item)
      })
    }

  },
  computed: {},
  
}
</script>
<style lang="sass" rel="stylesheet/sass">
.content-detail
  background-color: #e7f5f8
  width: max-content
  line-height: 2
  display: contents
</style>



// WEBPACK FOOTER //
// CargoOperation.vue?1b0996e0